module.exports = __webpack_public_path__ + "img/easyUse.26378df.svg";